import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { siteApi } from "../api";
import { PageHero } from "./parts";

export default function LegalPage() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [missing, setMissing] = useState(false);
  useEffect(() => { setPage(null); setMissing(false); siteApi.get(`/website/legal/${slug}`).then((r) => setPage(r.data)).catch(() => setMissing(true)); }, [slug]);
  if (missing) return <PageHero eyebrow="Fehler" title="Seite nicht gefunden" />;
  if (!page) return <div className="min-h-[40vh]" />;
  return (
    <>
      <PageHero eyebrow="Rechtliches" title={page.title} />
      <article className="max-w-3xl mx-auto px-5 py-12 text-stone-700 leading-relaxed whitespace-pre-line" data-testid="legal-content">{page.content}</article>
    </>
  );
}
